import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import axiosInstance, { handleApiError } from "../../services/axiosService";
import { useFormContext } from "../../context/FormContext";
import Loader from "../../Layouts/Loader/Loader";
import { getGridsOfFormFields, getMAppedAndModifiedFormField } from "../../commonFunctions/formFunc";
import { useAppUserContext } from "../../context/AppUserContext";
import { useTableContext } from "../../context/TableContext";
import AppUserEditor from "./AppUserEditor";
import ErrorMessage from "../../components/FormComponents/ErrorMessage";

const AppUserSection = () => {
  const { appUserData, setAppUserData } = useAppUserContext();
  const { renderFieldsData, setRenderFieldsArray } = useFormContext();
  const { getAllTableData } = useTableContext();

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const { appId } = useParams();

  const getAppUserData = async () => {
    try {
      setRenderFieldsArray([]);
      renderFieldsData.current = {};
      const { data } = await axiosInstance.get(`/userConfig`);

      setAppUserData(data);

      if (!data.fields) {
        setRenderFieldsArray([]);
        renderFieldsData.current = {};
      } else {
        const newRenderArray = getGridsOfFormFields(data.fields || []);
        const mappedObj = getMAppedAndModifiedFormField("", data.fields);
        setRenderFieldsArray(newRenderArray);
        renderFieldsData.current = mappedObj;
      }
    } catch (error) {
      handleApiError(error);
      setError(error.message);
    }
  };

  const initialFetching = async () => {
    setIsLoading(true);
    await getAllTableData();
    await getAppUserData();
    setIsLoading(false);
  };

  useEffect(() => {
    initialFetching();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appId]);

  if (isLoading) {
    return (
      <div className="d_flex justify_center align_center" style={{ height: "calc(100vh - 48px)" }}>
        <Loader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }

  if (!appUserData) return null;

  return (
    <section className="main_section">
      <AppUserEditor />
    </section>
  );
};

export default AppUserSection;
